// extracted by mini-css-extract-plugin
module.exports = {"productDisplayImageContainer":"style_productDisplayImageContainer__mk2yf"};